export const addPortfolio = 'ourWork';
export const updatePortfolio = 'ourWork/';
export const getPortfolio = 'ourWork';
export const deletePortfolio = 'ourWork/';
